


const systemSupport = {
  namespaced: true,
  state: {
    systemSupport: {}
  },
  getters: {
    systemSupport: state => state.systemSupport || {},
  },
  mutations: {
    SET_SYSTEMSUPPORT (state, payload) {
      state.systemSupport = payload
    },
    SET_SYSTEMSUPPORT_PARAMTER (state, payload) {
      // 直接异常抛掉
      if (payload.key == undefined || payload.key == null) throw Error("please check data key!")
      state.systemSupport[payload.key] = payload.value
    },
  },
  actions: {
    // 登录操作
    async updateSystemSupport (context, data) {
      // 触发mutation，存储data
      context.commit("SET_SYSTEMSUPPORT", data)
    },
  }
}

export default systemSupport